module.exports = __webpack_public_path__ + "static/media/Plus.42318f61.svg";